<template>
  <div>
	<!-- 直接引用 public 目录下的 HTML 文件 -->
	<iframe src="/emr-nursing-record4.html" style="width:100%;flex:1;" ref="myIframe" @load="sendDataToIframe"></iframe>
  </div>
</template>

<script>
	export default {
		props: ['item'],
		data() {
			return {
			}
		},
		methods: {
			sendDataToIframe() {
				const iframeWin = this.$refs.myIframe.contentWindow;
				if (iframeWin) {
					iframeWin.receiveVueData(this.item);
				}
			},
		},
		watch: {
			item(newv) {
				this.sendDataToIframe();
			},
		},
	}
</script>
